import { useContext } from 'react'

import { Form as FormProvider } from 'components/Form'
import Loading from 'components/Loading'
import { WorkspacePrebidConfigurationContext } from 'features/globalSetup/contexts/WorkspacePrebidConfigurationContext'
import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { Form } from './Form'
import { useUpdateWorkspacePrebidConfiguration } from './hooks/useUpdateWorkspacePrebidConfiguration'
import { Schema, schema, schemaDefault } from './schema'

export const FormContainer = (): JSX.Element => {
  const { formId, loading, setTouched, setValid, workspacePrebidConfiguration } = useContext(
    WorkspacePrebidConfigurationContext,
  )
  const { workspaceId } = useWorkspaceParam()
  const { errors: apiErrors, update } = useUpdateWorkspacePrebidConfiguration()

  if (!workspacePrebidConfiguration) {
    return <Loading />
  }

  return (
    <FormProvider<Schema>
      externalErrors={apiErrors}
      id={formId}
      loading={loading}
      onSubmit={update}
      onTouched={setTouched}
      onValid={setValid}
      schema={schema}
      schemaDefaults={schemaDefault(workspacePrebidConfiguration, workspaceId)}
    >
      {() => <Form />}
    </FormProvider>
  )
}
